var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.DataList),function(item,idx){return _c('div',{staticClass:"syitem",on:{"click":function($event){return _vm.ziXun(item)}}},[_vm._v(" "+_vm._s(item.cdate)+" 收益 ¥"+_vm._s(item.symoney)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }